var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 128.232,
  height: 130.456,
  viewBox: "0 0 128.232 130.456"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 128.232,
  height: 130.456,
  fill: "none"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4.093)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69.113,141.593c-16.846-16.844-35.318-25.683-41.26-19.743a5.94,5.94,0,0,0-1.4,2.417l-.1-.1-5.675,23.256-5.651,23.186-6.7,27.455-4.24,17.387,25.105-9.5L61.13,193.872,86.6,184.233l-.03-.03a5.929,5.929,0,0,0,2.282-1.35C94.8,176.911,85.959,158.439,69.113,141.593Z",
  transform: "translate(0 -87.398)",
  fill: "#dd1c4b"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 43.136,
  cy: 15.214,
  rx: 43.136,
  ry: 15.214,
  transform: "translate(78.099 106.205) rotate(-135)",
  fill: "#d1e3ee"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.292,354.492a21.3,21.3,0,0,1-8.85-1.756l-20.821,7.879L22.678,372.686,5.549,379.167l-1.456,5.97,25.105-9.5L61.13,363.555l23.38-8.846Z",
  transform: "translate(0 -256.905)",
  fill: "#b21d48"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(43.881 13.001)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M273.872,272.511a2.237,2.237,0,0,1-.763-.137,67.175,67.175,0,0,0-34.584-3.36l-7.763,1.293a2.173,2.173,0,0,1-.717-4.286l7.766-1.3a71.572,71.572,0,0,1,36.824,3.575,2.173,2.173,0,0,1-.763,4.219Z",
  transform: "translate(-207.163 -205.096)",
  fill: "#ffbf41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246.3,178.1a2.173,2.173,0,0,1-.935-4.13l45.642-21.734a2.174,2.174,0,0,1,1.869,3.925h0l-45.642,21.734A2.173,2.173,0,0,1,246.3,178.1Z",
  transform: "translate(-218.713 -123.721)",
  fill: "#ffbf41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.718,97.883a2.141,2.141,0,0,1-.835-.167,2.173,2.173,0,0,1-1.169-2.843h0l3.16-7.583a60.8,60.8,0,0,0,3.245-36.75,2.173,2.173,0,1,1,4.225-1.021c.006.026.012.052.017.078a65.116,65.116,0,0,1-3.477,39.367l-3.162,7.583a2.173,2.173,0,0,1-2,1.337Z",
  transform: "translate(-150.546 -47.855)",
  fill: "#ffbf41"
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4,
  cy: 4.5,
  rx: 4,
  ry: 4.5,
  transform: "translate(117.325 80.27)",
  fill: "#d5557e"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 4,
  cy: 4.5,
  rx: 4,
  ry: 4.5,
  transform: "translate(65.325 19.27)",
  fill: "#dd95c1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.44,8.694a4.347,4.347,0,1,1,4.347-4.347A4.347,4.347,0,0,1,160.44,8.694Z",
  transform: "translate(-110.705)",
  fill: "#7fcccb"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(101.897)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M390.266,46.52a2.174,2.174,0,0,1-2.173-2.173V42.173a2.173,2.173,0,0,1,4.347,0v2.173A2.173,2.173,0,0,1,390.266,46.52Z",
  transform: "translate(-381.573 -29.133)",
  fill: "#2276bb"
}), /*#__PURE__*/React.createElement("path", {
  d: "M390.266,6.52a2.174,2.174,0,0,1-2.173-2.173V2.173a2.173,2.173,0,0,1,4.347,0V4.347A2.173,2.173,0,0,1,390.266,6.52Z",
  transform: "translate(-381.573)",
  fill: "#2276bb"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.44,28.347h-2.173a2.173,2.173,0,1,1,0-4.347h2.173a2.173,2.173,0,1,1,0,4.347Z",
  transform: "translate(-393.226 -17.48)",
  fill: "#2276bb"
}), /*#__PURE__*/React.createElement("path", {
  d: "M368.44,28.347h-2.173a2.173,2.173,0,1,1,0-4.347h2.173a2.173,2.173,0,1,1,0,4.347Z",
  transform: "translate(-364.093 -17.48)",
  fill: "#2276bb"
})), /*#__PURE__*/React.createElement("path", {
  d: "M50.671,224.425c-.243-.93-.461-1.869-.663-2.825l-5.651,23.186.435,5.3a48.794,48.794,0,0,0,13.73,30.03l31.934-12.071c-.174-.054-.354-.093-.528-.152A63.721,63.721,0,0,1,50.671,224.425Z",
  transform: "translate(-29.325 -161.396)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.058,384.91c-.174-.054-.354-.093-.528-.152a63.56,63.56,0,0,1-6.138-2.7L83.629,392.938a48.667,48.667,0,0,0,3.5,4.053Z",
  transform: "translate(-57.928 -278.26)",
  fill: "#f6f6e7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M310.838,95.832v10.913H299.925V95.832Z",
  transform: "translate(-215.461 -69.797)",
  fill: "#c9da53"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.268,175.985a2.173,2.173,0,0,1-1.454-3.788l21.734-19.561a2.173,2.173,0,0,1,2.908,3.23l-21.734,19.561a2.174,2.174,0,0,1-1.454.559Z",
  transform: "translate(-134.013 -110.782)",
  fill: "#ffbf41"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.093 2.173)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M422.266,190.52a2.174,2.174,0,0,1-2.173-2.173v-2.173a2.173,2.173,0,1,1,4.347,0v2.173A2.173,2.173,0,0,1,422.266,190.52Z",
  transform: "translate(-307.075 -136.185)",
  fill: "#ffdb43"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446.507,180.579a2.157,2.157,0,0,1-1.537-.637l-1.537-1.537a2.173,2.173,0,0,1,3.073-3.073l1.537,1.537a2.173,2.173,0,0,1-1.537,3.71Z",
  transform: "translate(-323.63 -129.428)",
  fill: "#ffdb43"
}), /*#__PURE__*/React.createElement("path", {
  d: "M456.44,156.347h-2.173a2.173,2.173,0,1,1,0-4.347h2.173a2.173,2.173,0,1,1,0,4.347Z",
  transform: "translate(-330.381 -112.878)",
  fill: "#ffdb43"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444.9,129.675a2.173,2.173,0,0,1-1.537-3.71l1.537-1.537a2.173,2.173,0,0,1,3.073,3.073l-1.537,1.537a2.173,2.173,0,0,1-1.537.637Z",
  transform: "translate(-323.56 -92.353)",
  fill: "#ffdb43"
}), /*#__PURE__*/React.createElement("path", {
  d: "M422.266,118.52a2.174,2.174,0,0,1-2.173-2.173v-2.173a2.173,2.173,0,1,1,4.347,0v2.173A2.173,2.173,0,0,1,422.266,118.52Z",
  transform: "translate(-307.075 -83.745)",
  fill: "#ffdb43"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395.587,129.675a2.173,2.173,0,0,1-1.537-.637l-1.537-1.537a2.173,2.173,0,0,1,3.073-3.073l1.537,1.537a2.173,2.173,0,0,1-1.537,3.71Z",
  transform: "translate(-286.544 -92.353)",
  fill: "#ffdb43"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.96,8l3.358,6.8L25.827,15.9l-5.434,5.3,1.282,7.479L14.96,25.14,8.244,28.671l1.282-7.479L4.093,15.9,11.6,14.8Z",
  transform: "translate(-4.093 -8)",
  fill: "#ffdb43"
})), /*#__PURE__*/React.createElement("path", {
  d: "M388.145,368.291a15.086,15.086,0,0,0-6.664-8.783l-.9-1.343a32.8,32.8,0,0,0-21.823-14.112,2.173,2.173,0,0,0-.717,4.286,28.436,28.436,0,0,1,16.585,9.246,12.823,12.823,0,0,0-8.694,5.97,8.694,8.694,0,1,0,15.181,8.476,12.6,12.6,0,0,0,1.411-5.579,10.619,10.619,0,0,1,.476,11.287,2.173,2.173,0,1,0,3.739,2.218c.02-.033.038-.067.056-.1a15.117,15.117,0,0,0,1.345-11.565Zm-10.817,1.619a4.347,4.347,0,1,1-7.611-4.2l.02-.035a8.144,8.144,0,0,1,5.886-3.83,2.21,2.21,0,0,1,1.087.252C378.543,363.12,378.641,367.558,377.328,369.91Z",
  transform: "translate(-256.507 -250.565)",
  fill: "#2bb3ce"
})))));
export default __webpack_public_path__ + "static/media/illustration-questions.f9e3184f.svg";
export { SvgComponent as ReactComponent };